<template>
  <div>
    <div>
      <Tab
        :tabs="tabs"
        :current-tab="currentTab"
        @current-tab="currentTab = $event"
      />
    </div>
    <div v-if="currentTab === 'interStatePackages'">
   <inter-state-packages></inter-state-packages>
    </div>
    <div v-if="currentTab === 'interStateVehicle'">
<inter-state-vehicle></inter-state-vehicle >
    </div>
    <div v-if="currentTab === 'intraStatePackages'">
   <intra-state-packages></intra-state-packages>
    </div>
    <div v-if="currentTab === 'intraStateVehicle'">
<intra-state-vehicle></intra-state-vehicle >
    </div>

   
  </div>
</template>

<script>
import Tab from "../Tab.vue";
import InterStatePackages from "./InterStatePackages/Index.vue";
import InterStateVehicle from "./InterStateVehicle/Index.vue";
import IntraStatePackages from "./IntraStatePackages/Index.vue";
import IntraStateVehicle from "./IntraStateVehicle/Index.vue";
// import Modal from './Modal.vue'


export default {
  components: {
    Tab,
    IntraStateVehicle,
    IntraStatePackages,
    InterStateVehicle,
    InterStatePackages,
  
  },
  data() {
    return {
      estimatedCost:30000,
      selected: [],
      allSelected: false,
      indeterminate: false,
      item: false,
      showModal: false,
      showRoutes: false,
      viewAllRoutes: false,
shipmentPackages:['light', 'heavy', 'haulage'],
      routes: [
        "Lagos - Abuja",
        "Lagos - Enugu",
        "Lagos - Ibadan",
        "Lagos - Kano",
      ],
      tabs: [
        { id: "interStatePackages", value: "Inter State (Packages)" },
        { id: "interStateVehicle", value: "Inter State (Vehicle)" },
        // { id: "intraStatePackages", value: "Intra State (Packages)" },
        // { id: "intraStateVehicle", value: "Intra State (Vehicle)" },
      ],
      currentTab: "interStatePackages",
    };
  },
  methods: {
    toggleAll(checked) {
      this.selected = checked ? this.routes.slice() : [];
    },
  },
  watch: {
    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.routes.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style scoped>
.estimateBox{
  border: 1px solid #DAE8F6; border-radius: 2px; width: 207px; height: 44px; font-size:24px; font-weight: 600;
 margin-top: -10px;
  padding: 5.5px 10px 5.5px 80px ;
}
</style>
